import React from 'react';
import Icon from '../../../components/AppIcon';

const EnvironmentalBenefits = () => {
  const benefits = [
    {
      title: 'Redução de Emissões',
      description: 'Operação mais eficiente para reduzir impactos ambientais no dia a dia.',
      impact: 'Impacto positivo contínuo',
      icon: 'Cloud'
    },
    {
      title: 'Preservação de Recursos',
      description: 'Uso consciente de recursos naturais com foco em durabilidade e eficiência.',
      impact: 'Uso responsável de recursos',
      icon: 'TreePine'
    },
    {
      title: 'Infraestrutura Sustentável',
      description: 'Soluções técnicas que garantem operação estável e menor desperdício.',
      impact: 'Eficiência operacional',
      icon: 'Settings'
    },
    {
      title: 'Consciência Ambiental',
      description: 'Inspiramos outras empresas e pessoas a adotarem práticas sustentáveis.',
      impact: 'Multiplicador de impacto positivo',
      icon: 'Heart'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-muted/30 to-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            Benefícios Ambientais
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Nossa iniciativa de sustentabilidade gera impactos positivos que vão 
            além das nossas paredes, beneficiando toda a comunidade e o planeta.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-card rounded-2xl p-8 border border-border shadow-warm hover:shadow-warm-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name={benefit.icon} size={28} className="text-primary" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground mb-4 leading-relaxed">
                    {benefit.description}
                  </p>
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary border border-primary/20">
                    <Icon name="TrendingUp" size={16} />
                    <span className="text-sm font-medium">{benefit.impact}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to action */}
        <div className="mt-16 bg-gradient-to-br from-primary/10 via-accent/10 to-primary/10 rounded-2xl p-8 md:p-12 border border-primary/20 text-center">
          <Icon name="Sparkles" size={48} className="text-primary mx-auto mb-4" />
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            Juntos por um Futuro Sustentável
          </h3>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-6">
            A sustentabilidade é uma escolha diária. No Estação Marina, cada melhoria
            operacional contribui para um futuro melhor.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background/80 backdrop-blur-sm border border-border">
              <Icon name="CheckCircle" size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">Operação Eficiente</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background/80 backdrop-blur-sm border border-border">
              <Icon name="CheckCircle" size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">Impacto Positivo</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnvironmentalBenefits;
